export class BufferError extends Error {
	private error: string;
	constructor(message: string) {
		super(message);
		this.error = message;
		Object.setPrototypeOf(this, new.target.prototype);
	}
}
